import { Switch, XStack, YStack } from "tamagui";

import { Paragraph, Text } from "../Typography";

interface ToggleSwitchProps {
  label: string;
  description?: string;
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
  disabled?: boolean;
}

export default function ToggleSwitch({
  label,
  description,
  checked,
  onCheckedChange,
  disabled = false,
}: ToggleSwitchProps) {
  return (
    <XStack gap="$200" alignItems="center">
      <YStack flex={1} marginRight="auto" gap="$100">
        <Text size="$sm" medium>
          {label}
        </Text>
        {description && (
          <Paragraph size="$xs" lineHeight="$sm">
            {description}
          </Paragraph>
        )}
      </YStack>
      <Switch
        checked={checked}
        onCheckedChange={onCheckedChange}
        size="$300"
        disabled={disabled}
        cursor={disabled ? "not-allowed" : "pointer"}
        opacity={disabled ? 0.5 : 1}
        width="$450"
        height="$250"
        padding="$25"
        justifyContent="center"
        backgroundColor="$strokeUnselected"
        borderColor="$strokeUnselected"
        activeStyle={{
          backgroundColor: "$buttonHighlight",
          borderColor: "$buttonHighlight",
        }}
      >
        <Switch.Thumb backgroundColor="$fillModal" transition="standard" />
      </Switch>
    </XStack>
  );
}
